import React, { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import {
  Container,
  ElementContainer,
  NBACard,
  NBATitleRow,
  NBAIconWrapper,
  NBATitle,
  NBAFeedback,
} from "./InformationCards.styled";
import { HighlightCards, Skeleton, Icon } from "@ann/web-components";
import { getNoteSnapshot } from "../../../../../../../services/notes";

const InformationCards = () => {
  const { contactId } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [nbaData, setNbaData] = useState(null);

  const fetchNbaData = useCallback(async () => {
    if (!contactId) {
      setIsLoading(false);
      return;
    }

    try {
      const response = await getNoteSnapshot(contactId);

      if (response?.statusCode === 200 && Array.isArray(response.body)) {
        // Find the NBA note type from the response
        const nbaGroup = response.body.find(
          (group) => group.note_type === "NBA"
        );

        if (nbaGroup && nbaGroup.notes?.length > 0) {
          // Get the most recent NBA note
          const latestNba = nbaGroup.notes[0];
          setNbaData({
            content: latestNba.note_content,
            createdAt: latestNba.created_at,
          });
        } else {
          setNbaData(null);
        }
      }
    } catch (error) {
      console.error("Error fetching NBA data:", error);
      setNbaData(null);
    } finally {
      setIsLoading(false);
    }
  }, [contactId]);

  useEffect(() => {
    fetchNbaData();
  }, [fetchNbaData]);

  if (isLoading) {
    return (
      <Container>
        <ElementContainer>
          <Skeleton height="120px" width="100%" />
        </ElementContainer>
      </Container>
    );
  }

  return (
    <Container>
      {/* <ElementContainer>
        <HighlightCards
          color="body"
          feedback="No follow-up in last 7 days"
          icon="email"
          iconBgColor="alert"
          iconColor="alert"
          iconSize="medium"
          label="Follow-up Needed"
          showIcon
          unit=""
          value="Yes"
        />
      </ElementContainer>
      <ElementContainer>
        <HighlightCards
          color="body"
          feedback="Test drive confirmed"
          icon="calendarToday"
          iconBgColor="success"
          iconColor="success"
          iconSize="medium"
          label="May 23"
          showIcon
          unit="10 am"
          value="May 23"
        />
      </ElementContainer>
      <ElementContainer>
        <HighlightCards
          color="body"
          feedback="Vehicles of Interest"
          icon="directionsCar"
          iconBgColor="primary"
          iconColor="primary"
          iconSize="medium"
          label="May 23"
          showIcon
          unit="Models"
          value="5"
        />
      </ElementContainer> */}
      <ElementContainer>
        <NBACard>
          <NBATitleRow>
            <NBAIconWrapper>
              <Icon name="aiChat" size="medium" />
            </NBAIconWrapper>
            <NBATitle>Next Best Action</NBATitle>
          </NBATitleRow>
          <NBAFeedback>
            {nbaData ? nbaData.content : "No best action calculated"}
          </NBAFeedback>
        </NBACard>
      </ElementContainer>
    </Container>
  );
};

export default InformationCards;
